/**
 * Cart Upsell Carousel
 * - Variant select: updates hidden input + displayed price
 * - Add-to-cart animation: triggers the checkmark burst on submit
 * - Prevents slideshow drag from blocking interactive elements (select, button)
 * Carousel behaviour is handled by the theme's native slideshow-component.
 */

/*
 * Stop mousedown from reaching the slideshow's drag handler
 * on interactive elements. The slideshow calls event.preventDefault()
 * on all mousedowns which blocks native <select> from opening.
 */
document.addEventListener(
  'mousedown',
  (e) => {
    if (e.target.closest('.mp-cart-upsell__card select, .mp-cart-upsell__card button, .mp-cart-upsell__card a')) {
      e.stopPropagation();
    }
  },
  true
);

/* Variant select */
document.addEventListener('change', (e) => {
  const select = e.target.closest('[data-upsell-variant-select]');
  if (!select) return;

  const card = select.closest('.mp-cart-upsell__card');
  if (!card) return;

  const selectedOption = select.options[select.selectedIndex];
  const variantInput = card.querySelector('input[name="id"]');
  const priceDisplay = card.querySelector('[data-upsell-price-display]');

  if (variantInput) {
    variantInput.value = select.value;
  }

  if (priceDisplay && selectedOption) {
    priceDisplay.textContent = selectedOption.dataset.price;
  }
});

/* Add-to-cart animation on submit */
document.addEventListener('submit', (e) => {
  const card = e.target.closest('.mp-cart-upsell__card');
  if (!card) return;

  const btn = card.querySelector('.mp-cart-upsell__add-btn');
  if (!btn || btn.dataset.added === 'true') return;

  btn.dataset.added = 'true';
});
